"use client";

import { c as _c } from "react/compiler-runtime";
import css from "./header.module.scss";
import HomeNavigationItemWithSubnavigation, { HomeNavigationItemWithSubnavigationRef } from "@/components/home/home-navigation-item-with-subnavigation/home-navigation-item-with-subnavigation";
import Link, { LinkType } from "../link/link";
import { useRef } from "react";
import BaseLink from "../base-link/base-link";
import GridColumn from "../grid-column/grid-column";
import GridRow from "../grid-row/grid-row";
import HeaderLinks from "./header-links/header-links";
import HeaderMenu from "./header-menu/header-menu";
import Image from "../image/image";
import { Navigation, SiteSettings } from "@/sanity/sanity.types";
import { useLayout } from "@/contexts/layout-context";
export interface IHeaderProps {
  data: Navigation;
  siteSettings: SiteSettings;
}
const Header = props => {
  const $ = _c(44);
  const {
    siteSettings,
    data
  } = props;
  let t0;
  if ($[0] !== data) {
    t0 = data || {};
    $[0] = data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    items,
    primaryCta
  } = t0;
  let t1;
  if ($[2] !== siteSettings) {
    t1 = siteSettings || {};
    $[2] = siteSettings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    trustBar
  } = t1;
  const {
    setNavOpen
  } = useLayout();
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      setExpanded: _temp
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const submenuRef = useRef(t2);
  let t3;
  if ($[5] !== setNavOpen) {
    t3 = ref => {
      if (submenuRef.current && submenuRef.current !== ref) {
        submenuRef.current.setExpanded(false);
      }
      submenuRef.current = ref;
      setNavOpen(true);
    };
    $[5] = setNavOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onSubmenuOpen = t3;
  let t4;
  if ($[7] !== setNavOpen) {
    t4 = ref_0 => {
      if (submenuRef.current === ref_0) {
        setNavOpen(false);
      }
    };
    $[7] = setNavOpen;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onSubmenuClose = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BaseLink href="/" data-cta-id="logo" data-cta-value="logo-header"><Image className={css.headerMobileLogo} src="/logo.svg" alt="Amerisave Logo" width={160} height={40} fetchPriority="high" /></BaseLink>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== items || $[11] !== primaryCta || $[12] !== trustBar) {
    t6 = items && <HeaderMenu data={items} primaryCta={primaryCta} className="md:hidden" trustBar={trustBar} />;
    $[10] = items;
    $[11] = primaryCta;
    $[12] = trustBar;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== primaryCta) {
    t7 = primaryCta?.link && <Link href={primaryCta.link.href ?? "#"} linkType={LinkType.BUTTON} data-cta-id={primaryCta?.link?.ctaId ?? ""} data-cta-value={primaryCta?.link?.ctaValue ?? ""}>{primaryCta.link.label}</Link>;
    $[14] = primaryCta;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== items) {
    t8 = items && <HeaderMenu data={items} />;
    $[16] = items;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className="hidden items-center gap-8 md:flex">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t6 || $[22] !== t9) {
    t10 = <div className={`${css.headerMobile} !flex xl:!hidden`}><GridRow><GridColumn><div className={`${css.headerMobileContent} h-[72px]`}>{t5}{t6}{t9}</div></GridColumn></GridRow></div>;
    $[21] = t6;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <BaseLink href="/" data-cta-id="logo" data-cta-value="logo-header" className="relative"><Image className={`relative ${css.headerDesktopLogo} top-[-5px]`} src="/logo.svg" alt="Amerisave Logo" width={160} height={40} fetchPriority="high" /></BaseLink>;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== items || $[26] !== onSubmenuClose || $[27] !== onSubmenuOpen) {
    t12 = !!items?.length && <nav className={css.headerDesktopNav}><ul className={`${css.headerDesktopNavList} relative`}>{items.filter(_temp2).map((item_0, index) => <li key={index}>{!!item_0.children?.length ? <HomeNavigationItemWithSubnavigation data={item_0} onOpen={onSubmenuOpen} onClose={onSubmenuClose} /> : <BaseLink className={css.headerDesktopNavListItemLink} href={item_0.link.href ?? ""} data-cta-id={item_0?.link?.ctaId ?? ""} data-cta-value={item_0?.link?.ctaValue ?? ""} rel={item_0?.link?.nofollow}>{item_0.link.label}</BaseLink>}</li>)}</ul></nav>;
    $[25] = items;
    $[26] = onSubmenuClose;
    $[27] = onSubmenuOpen;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12) {
    t13 = <div className="flex items-center justify-center gap-6">{t11}{t12}</div>;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== trustBar) {
    t14 = trustBar && <div className={css.headerLinksWrapper}><HeaderLinks data={trustBar} className={css.stickyHeader} /></div>;
    $[31] = trustBar;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== primaryCta) {
    t15 = primaryCta?.link && <Link href={primaryCta.link.href ?? "#"} linkType={LinkType.BUTTON} className="whitespace-nowrap" data-cta-id={primaryCta.link?.ctaId ?? ""} data-cta-value={primaryCta.link?.ctaValue ?? ""} rel={primaryCta?.link?.nofollow}>{primaryCta.link.label}</Link>;
    $[33] = primaryCta;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15) {
    t16 = <div className="flex items-center justify-center gap-6">{t14}{t15}</div>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t13 || $[39] !== t16) {
    t17 = <div className={`${css.headerDesktop} !hidden xl:!flex`}><div className={css.headerDesktopBottom}><GridRow className="!max-w-[1488px]"><GridColumn><div className={css.headerDesktopBottomContent}>{t13}{t16}</div></GridColumn></GridRow></div></div>;
    $[38] = t13;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t10 || $[42] !== t17) {
    t18 = <header id="header" className={`${css.header} sticky top-0 z-[1000] bg-[#FFF] text-[#373B37]`}>{t10}{t17}</header>;
    $[41] = t10;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};
export default Header;
function _temp() {}
function _temp2(item) {
  return item.link;
}